module.exports = __webpack_public_path__ + "img/20180815_145911_030.58697e7d.jpg";